import React from 'react';
import ReactPlayer from 'react-player/vimeo';

const VideoVimeo = () => {
    return (
        <div className='col-lg-12'>
            <ReactPlayer
                url="https://vimeo.com/1029239496"
                controls
                width="100%"
                height="600px"
                
            />
        </div>
    );
};

export default VideoVimeo;
